import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// styles
import styles from "./styles";

class Link extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
    href: PropTypes.string,
  };

  render() {
    const { children, classes, href } = this.props;

    return (
      <a
        className={classes.link}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }
}

export default withStyles(styles)(Link);
